module.exports = __webpack_public_path__ + "img/76.1372de19.jpg";